<template>
    <div class="bidding">
        <div class="list">
            <div>类型</div>
            <span v-for="(item,index) in projectDict.bg_project_category" :key="index" :class="{ active :cateinx == index }" @click="getCate(item,index)">{{ item.dict_label }}</span>
        </div>
       <div class="list">
            <div>类别</div>
            <span :class="{ active : lbinx == 100 }" @click="setlbList(1,100)">全部</span>
            <span v-for="(item,index) in projectCategoryList" :key="index" :class="{ active :lbinx == index }" @click="setlbList(item,index)">{{ item.dict_label }}</span>
        </div>
        <div class="list">
                <div>价格</div>
                <span :class="{ active : priceinx == 10 }" @click="priceCate(1,10)">全部</span>
                <span v-for="(item,index) in projectDict.bg_quotation_price" :key="index" :class="{ active :priceinx == index }"  @click="priceCate(item,index)">{{ item.dict_label }}</span>
                
        </div>
        <div class="list">
                <div>状态</div>
                <span :class="{ active : stateinx == 10 }" @click="getState(1,10)">全部</span>
                <span v-for="(item,index) in biddingStateList" :key="index" :class="{ active :stateinx == index }"  @click="getState(item,index)">{{ item.label }}</span>
                
        </div>
        <!-- <a-spin :spinning="spinning">
            <div class="list">
                    <div style="line-height:30px;">地区</div>
                    <div class="area">
                        <span :class="{ active : areainx == 100 }" @click="getarealist(1,100)">全部</span>
                        <span v-for="(item,index) in areaList" :key="index" :class="{ active :areainx == index }"  @click="getarealist(item,index)">{{ item.name }}</span>
                    </div>
            </div>
            <div class="list" v-if="childremList.length>0">
                    <div style="line-height:30px;">街道</div>
                    <div class="area">
                        <span :class="{ active : childinx == 100 }" @click="getChildlist(1,100)">全部</span>
                        <span v-for="(item,index) in childremList" :key="index" :class="{ active :childinx == index }"  @click="getChildlist(item,index)">{{ item.name }}</span>
                    </div>
            </div>
         </a-spin>  -->
        <div class="queta-list" v-loading="loadingDiv" style="min-height:330px;">
            <div class="main-detail" v-for="(item,index) in dataList" :key="index">
                <div class="mainImg" @click="$router.push({ path:'/biddingDetail',query:{ id:item.id } })"><img :src="item.pictureUrl[0]"></div>
                <div class="intro">
                    <div><span>项目名称：{{ item.projectName }}</span>
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span class="address">地址：{{ item.cityName + item.countyName + item.townName + item.villageName }}</span>
                            </template>
                            <span class="address">{{ item.cityName + item.countyName + item.townName + item.villageName }}</span>
                        </a-tooltip>
                    </div>
                    <div><span>类别：{{ item.projectCategoryName }}</span><span>状态：{{ item.biddingStateName }}</span></div>
                    <div><span>起拍价：{{ item.biddingPrice }}万元</span>
                         <span>加价幅度：{{ item.biddingUp }}元</span>
                         <a-button type="primary" size="small" v-if="item.isApply!='3'" :disabled="item.isApply=='0'?false:true" @click="setOrder(item)">{{ item.isApply=='0'?'报名':item.isApply=='1'?'已报名':item.isApply=='2'?'结束':'' }}</a-button>
                    </div>
                </div>
            </div> 
            <div v-if="dataList.length==0" style="width:100%;height:330px;display:flex;justify-content: center;align-items: center;">
                  未查询到相关数据
            </div>      
        </div>   
        <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
        <a-modal title="确定报名？" :visible="visible" :confirmLoading="loading"  cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
            <p>起拍价格：{{ currentItem.biddingPrice }}万元 </p>
            <p>收款人：{{ bankInfo.receiver }}</p>
            <p>银行信息：{{ bankInfo.bankInformation }}</p>
            <p>银行账号：{{ bankInfo.bankAccount }}</p>
            <p>支付(信用)凭证</p>
            <upload ref="upload" :imageUrl="imageUrl" @getFile="getFile"></upload>
        </a-modal>
    </div>   
   
</template>

<script>
import upload from '@/components/uploadnomu.vue'
const biddingStateList = [
    // { id:'0',label:'待公示' },
    { id:'1',label:'公示中' },
    { id:'2',label:'竞拍中' },
    { id:'3',label:'已结束' },
    { id:'4',label:'流拍' },
]
export default {
    components:{
        upload
    },
    data(){
        return{
            biddingStateList:biddingStateList,
            projectDict:'',
            cateinx:0,
            natinx:10,
            priceinx:10,
            stateinx:10,
            areainx:100,
            childinx:100,
            lbinx:100,
            childremList:[],
            params:{
                projectType:'01',
                projectCategory:'',//类别
                projectNature:'',//性质
                quotationPrice:'',//价格
                biddingState:'',//状态
                cityCode:'',//地区
                countyCode:'',
                pageSize:10,
                pageNum:1
            },
            dataList:[],
            areaList:[],
            spinning:false,
            total:0,
            visible:false,
            currentItem:'',
            value:'',
            query:{
                biddingId:'',
                applyUrl:'',
            },
            loading:false,
            imageUrl:'',
            projectCategoryList:[],
            loadingDiv:false,
             bankInfo:''
        }
    },
    created(){
        this.$https.get('/portal/bidding/updateBiddingState').then(res=>{ })
        //获取字典
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                    this.getCate(this.projectDict.bg_project_category[0],0)
                }else{
                     this.$message.info(res.msg)
                }
        })
        this.getArea();
        if(this.$route.query.index){
            this.natinx = this.$route.query.index;
            this.getDataList();
        }else{
            this.getDataList();
        }
        this.$https.get('/system/bank/bankList').then(res=>{
            if(res.code == 200){
                this.bankInfo = res.rows[0];
            }else{
                this.$message.error('获取失败')
            }
        })
    },
    mounted(){
        this.$parent.current = '3';
    },
    methods:{
        getCate(item,index){
            this.cateinx = index;
            this.lbinx = 100;
            this.params.projectType = item.dict_value;
            this.getDataList();
            this.$https.get(`/portal/projectDict/getListByProjectType/${item.dict_value}`).then(res=>{
                 if(res.code == 200){
                     this.projectCategoryList = res.rows
                 }
            })
        },
        setlbList(item,index){
            this.params.projectCategory = item==1?'':item.dict_value;
            this.lbinx = index;
            this.getDataList();
        },
        getNature(item,index){
            this.natinx = index;
            this.params.projectNature = item.dict_value;
            this.getDataList();
        },
        priceCate(item,index){
            this.priceinx = index;
            this.params.quotationPrice = item==1?'':item.dict_value;
            this.getDataList();
        },
        getarealist(item,index){
            this.areainx = index;
            this.params.cityCode = item.code;
            this.childremList = item.childremList;
            this.getDataList();
        },
        getState(item,index){
            this.stateinx = index;
            this.params.biddingState = item==1?'':item.id;
            this.getDataList();
        },
        getChildlist(item,index){
            this.params.countyCode = item.code;
            this.childinx = index;
            this.getDataList();
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getArea(){
            this.spinning = true;
            this.$https.get('/portal/projectDict/dictAreaList').then(res=>{
                this.spinning = false;
                if(res.code == 200){
                    this.areaList = res.rows;
                }
            }).catch(()=>{
                this.spinning = false;
            })
        },
        getDataList(){
            //更新状态/portal/bidding​/updateBiddingState
           this.getbiddingList();
        },
        getbiddingList(){
            this.loadingDiv = true;
            this.$https.get('/portal/bidding/biddingList',{params:this.params}).then(res=>{
                this.loadingDiv = false;
                if(res.code == 200){
                    res.rows.forEach(item=>{
                        item.pictureUrl = item.pictureUrl.split(',');
                    })
                    this.dataList = res.rows
                    this.total = Number(res.total);
                }
            }).catch(error=>{
                    this.loadingDiv = false;
                    this.$message.error(res.msg)
            })
        },
        handleOk(){
            console.log(this.currentItem)
            if(!this.imageUrl){
               this.$message.info('请上传支付(信用)凭证');
               return false
            }
            this.loading = true;
            this.query.biddingId = this.currentItem.id;
            this.query.applyUrl = this.imageUrl;
            this.$https.post('/portal/bidding/projectBiddingApply',this.query).then(res=>{
                this.loading =false;
                if(res.code == 200){
                    this.$message.success('报名成功');
                    this.params.pageNum = 1;
                    this.getDataList();
                    this.visible = false;
                }else{
                    this.$message.info(res.msg)
                }
            }).catch(error=>{
                this.$message.info(error.msg)
                this.loading = false;
            })
        },
        handleCancel(){
            this.visible = false;
        },
        setOrder(item){
            this.currentItem = item;
            this.visible = true;
        },
        getFile(info){
           this.imageUrl = info.file.response.data.url;

        }
    }
}
</script>

<style lang="less" scoped>
.bidding{
    width: 1300px;
    margin:0 auto;
    background: #fff;
    padding:20px 20px 50px 20px;
    .list{
        display: flex;
        flex-wrap:wrap;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        color:#333;
        div{
            margin-right:20px;
            font-weight: bold;
            padding:3px 5px;
        }
        .area{
            width: 1160px;
            font-weight: 500;
            line-height: 35px;
            padding: 0;
        }
        span{
            margin-right:10px;
            cursor: pointer;
            padding:3px 5px;
            border-radius: 2px;
        }
        .active{
            background: red;
            color:#fff;
        }
    }
    .queta-list{
        display: flex;
        flex-wrap:wrap;
        margin:20px 0;
        .main-detail{
            margin-right:20px;
            .mainImg{
                width: 400px;
                height: 270px;
                border:1px solid #eeeeee;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                cursor: pointer;
                img{
                    width: 400px;
                    height: auto;
                }
            }
            .intro{
                display: flex;
                flex-direction: column;
                div{
                    line-height: 35px;
                    &:nth-of-type(1){
                        display: flex;
                        justify-content: space-between;
                        span{
                            white-space:nowrap; 
                            overflow:hidden; 
                            text-overflow:ellipsis; 
                            white-space:nowrap; 
                            width: 200px;
                        }
                    }
                    &:nth-of-type(2){
                        display: flex;
                        justify-content: space-between;
                    }
                    &:nth-of-type(3){
                        display: flex;
                        justify-content: space-between;
                        .ant-btn{
                            margin-top:5px;
                        }
                    }
                }
            }
        }
    } 
    .address{
        width: 200px;
        overflow: hidden;
    }

    // max-width:200px;
    // white-space:nowrap; 
    // overflow:hidden; 
    // text-overflow:ellipsis; 
    // white-space:nowrap; 
}
</style>